import { render, staticRenderFns } from "./Redactor.vue?vue&type=template&id=1bf7a52e&"
import script from "./Redactor.vue?vue&type=script&lang=js&"
export * from "./Redactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Redactor.vue?vue&type=custom&index=0&blockType=styles&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports